import { render, staticRenderFns } from "./SimpleMap.vue?vue&type=template&id=84c6976a&scoped=true"
import script from "./SimpleMap.vue?vue&type=script&lang=ts"
export * from "./SimpleMap.vue?vue&type=script&lang=ts"
import style0 from "./SimpleMap.vue?vue&type=style&index=0&id=84c6976a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c6976a",
  null
  
)

export default component.exports